export default __webpack_public_path__ + "static/media/nex-patient.b6bc199d.png";